import COLORS from '@/constants/colors';

export default {
  dialog: {
    '& .MuiPaper-root': {
      background: COLORS.gray_50,
    },
    '& .MuiBackdrop-root': {},
  },
  dialogHeaderContainer: {
    justifyContent: 'space-between',
  },
  sectionTitle: {
    fontWeight: 500,
    fontSize: '14px',
    color: COLORS.gray_700,
  },
  dialogHeader: {
    fontSize: '18px',
    fontWeight: 600,
    color: COLORS.gray_600,
    margin: 0,
    alignContent: 'center',
  },
  dialogContentContainer: {
    direction: 'column',
    background: 'white',
    border: `1px solid ${COLORS.gray_300}`,
    pl: '16px',
    pr: '16px',
    pt: '24px',
    pb: '24px',
    borderRadius: '16px',
    gap: '24px',
  },
  confirmButton: {
    ml: '16px',
    mr: '16px',
    mb: '16px',
  },
};
